import React from "react";
import classNames from "classnames";
import "../cdn.scss";
import { Button } from "../Button";
const FormGroupElement = props => {
  const {
    type,
    id,
    value,
    disabled = false,
    className
  } = props;
  if (type === "button") {
    const {
      btnType,
      btnSubmit = false,
      submit = false,
      reset = false,
      spinner = false,
      spinnerPosition = "prepend",
      onClick
    } = props;
    return /*#__PURE__*/React.createElement(Button, {
      type: btnType,
      submit: !reset && (submit || btnSubmit),
      reset: reset && !submit && !btnSubmit,
      disabled: disabled,
      className: className,
      spinner: spinner,
      spinnerPosition: spinnerPosition,
      onClick: onClick
    }, value);
  }
  if (type === "select") {
    const {
      options = [],
      onChange
    } = props;
    return /*#__PURE__*/React.createElement("div", {
      className: "form-select"
    }, /*#__PURE__*/React.createElement("select", {
      id: id,
      className: className,
      onChange: onChange
    }, options.map(option => /*#__PURE__*/React.createElement("option", {
      key: option.value,
      value: option.value,
      selected: option.value === value
    }, option.label))));
  }
  const {
    onChange
  } = props;
  if (type === "radio") {
    const {
      options = []
    } = props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, options.map(option => /*#__PURE__*/React.createElement("div", {
      className: "form-radio",
      key: option.value
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      className: classNames("form-radio-input", className),
      id: "".concat(id, "-").concat(option.value),
      value: option.value,
      checked: value === option.value,
      onChange: onChange
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "".concat(id, "-").concat(option.value),
      className: "form-radio-label"
    }, option.label))));
  }
  if (type === "checkbox") {
    const {
      options = [],
      value
    } = props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, options.map(option => /*#__PURE__*/React.createElement("div", {
      className: "form-check",
      key: option.value
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: classNames("form-check-input", className),
      id: "".concat(id, "-").concat(option.value),
      value: option.value,
      checked: value.includes(option.value),
      onChange: onChange
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "".concat(id, "-").concat(option.value),
      className: "form-check-label"
    }, option.label))));
  }
  const {
    placeholder,
    readOnly = false,
    icon,
    onClick,
    ariaLabel
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: type,
    placeholder: placeholder,
    value: value,
    onChange: onChange,
    readOnly: readOnly,
    disabled: disabled,
    className: className,
    "aria-label": ariaLabel
  }), icon && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-4 right-5",
    onClick: value && onClick || undefined
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-regular mt-1 ".concat(value ? "fa-xmark mr-1 po cursor-pointer" : icon)
  })));
};
export const FormGroup = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    id,
    label,
    labelTag,
    type,
    mt,
    mb,
    reversed = false
  } = props;
  const LabelTag = labelTag || (type === "radio" || type === "checkbox" ? "h2" : "label");
  const classes = {
    "form-group": type !== "select"
  };
  classes["mt-".concat(mt)] = !!mt;
  classes["mb-".concat(mb)] = !!mb;
  const Label = () => /*#__PURE__*/React.createElement(LabelTag, {
    htmlFor: LabelTag === "label" ? id : undefined,
    className: labelTag !== "label" ? "fs-h4" : undefined
  }, label);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes),
    ref: ref
  }, label && !reversed && /*#__PURE__*/React.createElement(Label, null), /*#__PURE__*/React.createElement(FormGroupElement, props), label && reversed && /*#__PURE__*/React.createElement(Label, null));
});